module.exports = __webpack_public_path__ + "static/media/white_running_man.e032f57a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/white_running_man.svg
// module id = 983
// module chunks = 0